import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import qs from 'qs'
import { useStateValue } from '@State'
import { client } from '@Utils'
import { gradebook as endpoints } from '@URLS'

const FIELDS = [
  { value: 'Points', label: 'Points' },
  { value: 'Started', label: 'Start Time' },
  { value: 'Submitted', label: 'Submission Time' },
  { value: 'Graded', label: 'Grade Time' },
]

const FILETYPES = [
  { value: 'xlsx', label: 'Microsoft Excel', icon: 'fal fa-file-excel' },
  { value: 'csv', label: 'Comma Delimited Text', icon: 'fal fa-file-csv' },
]

const FORMATS = [
  { value: 'standard', label: 'Standard' },
  { value: 'canvas', label: 'Canvas-upload Compatible' },
]

export const DownloadWidget = () => {
  const [currentState] = useStateValue()
  const [showDownloadForm, setShowDownloadForm] = useState(false)
  const [fileType, setFileType] = useState('xlsx')
  const [format, setFormat] = useState('standard')
  const [includeFilters, setIncludeFilters] = useState(false)
  const [actPointTotalsRow, setActPointTotalsRow] = useState(false)
  const [totalLTILaunchesAndSubs, setTotalLTILaunchesAndSubs] = useState(false)
  const [fieldPoints, setFieldPoints] = useState(false)
  const [fieldStarted, setFieldStarted] = useState(false)
  const [fieldSubmitted, setFieldSubmitted] = useState(false)
  const [fieldGraded, setFieldGraded] = useState(false)

  const getters = {
    fieldPoints: fieldPoints,
    fieldStarted: fieldStarted,
    fieldSubmitted: fieldSubmitted,
    fieldGraded: fieldGraded,
  }
  const setters = {
    fieldPoints: setFieldPoints,
    fieldStarted: setFieldStarted,
    fieldSubmitted: setFieldSubmitted,
    fieldGraded: setFieldGraded,
  }

  const startDownload = (data, filters) => {
    const baseUrl = endpoints.download()
    const url =
      filters != null ? `${baseUrl}?${qs.stringify(filters)}` : baseUrl

    return async () => {
      try {
        await client.post(url, data)
      } catch (error) {
        return reportError('Initiating the gradebook download task failed.')
      }
      window.$('#widget_container').trigger('reload_widgets')
    }
  }

  const submitForm = event => {
    event.target.disabled = true

    let fields = FIELDS.map(({ value }) => 'field' + value)
      .filter(field => getters[field])
      .map(field => field.slice(5))

    setShowDownloadForm(false)

    const data = {
      fileType: fileType,
      format: format,
      pointTotals: actPointTotalsRow,
      totalLTILaunchesAndSubs: totalLTILaunchesAndSubs,
      fields,
    }
    const filters = includeFilters ? { ...currentState.filters } : {}

    startDownload(data, filters)()
  }

  const handleFileType = event => {
    let checked = event.target.checked
    if (checked) {
      setFileType(event.target.value)
    }
  }

  const handleFormat = event => {
    let checked = event.target.checked
    if (checked) {
      // this.setState({
      //   format: event.target.value,
      // })
      setFormat(event.target.value)
    }
  }

  const handleCheckbox = event => {
    let name = event.target.name
    let checked = event.target.checked
    setters[name](checked)
  }

  const renderForm = () => {
    let filetypes = FILETYPES.map(({ value, label, icon }) => (
      <label className="radio-inline" key={value}>
        <input
          type="radio"
          name="fileType"
          value={value}
          checked={fileType === value}
          onChange={handleFileType}
        />
        <span className={icon} /> {label}
      </label>
    ))

    let formats = FORMATS.map(({ value, label }) => (
      <label className="radio-inline" key={value}>
        <input
          type="radio"
          name="format"
          value={value}
          checked={format === value}
          onChange={handleFormat}
        />
        {label}
      </label>
    ))

    let fields = FIELDS.map(({ value, label }) => (
      <div className="checkbox" key={value}>
        <label>
          <input
            type="checkbox"
            name={`field${value}`}
            checked={getters[`field${value}`]}
            onChange={handleCheckbox}
          />
          {label}
        </label>
      </div>
    ))

    return (
      <div className="form-horizontal">
        <div className="form-group">
          <label className="control-label">
            <strong>File Type:</strong>
          </label>
          <div>{filetypes}</div>
        </div>
        {currentState.isCanvasCourse && (
          <div className="form-group">
            <label className="control-label">
              <strong>Format:</strong>
            </label>
            <div>{formats}</div>
          </div>
        )}
        <div className="form-group">
          <label className="control-label">
            <input
              type="checkbox"
              name="includeFilters"
              checked={includeFilters}
              onChange={() => setIncludeFilters(!includeFilters)}
            />
            <strong className="ml-2">Apply Filters</strong>
          </label>
        </div>
        <div className="form-group">
          <label className="control-label">
            <input
              type="checkbox"
              name="actPointTotalsRow"
              checked={actPointTotalsRow}
              onChange={() => setActPointTotalsRow(!actPointTotalsRow)}
            />
            <strong className="ml-2">
              Include Activity Points on First Row
            </strong>
          </label>
        </div>
        {currentState.showAccountingButton && (
          <div className="form-group">
            <label className="control-label">
              <input
                type="checkbox"
                name="totalLTILaunchesAndSubs"
                checked={totalLTILaunchesAndSubs}
                onChange={() =>
                  setTotalLTILaunchesAndSubs(!totalLTILaunchesAndSubs)
                }
              />
              <strong className="ml-2">
                Include Columns for Total LTI Launches and Assessment
                Submissions
              </strong>
            </label>
          </div>
        )}
        <div className="form-group">
          <label className="control-label">
            <strong>Optional Fields:</strong>
          </label>
          <div>{fields}</div>
        </div>
      </div>
    )
  }

  return (
    <div className="d-inline ml-3">
      <Button
        id="downloadGradebookButton"
        variant="primary"
        onClick={() => setShowDownloadForm(true)}
        className="btn-myed btn-primary-myed"
      >
        <i className="fa-solid fa-arrow-to-bottom icon_color_white" /> Download
        Gradebook
      </Button>
      <Modal show={showDownloadForm} onHide={() => setShowDownloadForm(false)}>
        <Modal.Header>
          <Modal.Title>Download Gradebook</Modal.Title>
        </Modal.Header>
        <Modal.Body>{renderForm()}</Modal.Body>
        <Modal.Footer>
          <Button
            id="cancelButton"
            onClick={() => setShowDownloadForm(false)}
            className="btn-myed btn-default-myed"
          >
            Cancel
          </Button>
          <Button
            id="startDownloadGradebookButton"
            onClick={submitForm}
            variant="primary"
            className="btn-myed btn-primary-myed"
          >
            <i className="fa-solid fa-arrow-to-bottom" /> Download
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
